// src/modules/app-views/toolbox/pages/Init/components/tableColumns/categoryColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function categoryColumn(buildColumnProps, options = {}) {
  const {
    key = 'categories',
    title = 'category',
    dataIndex = 'categories',
    width = 200,
    columnProps = { sort: false },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => r?.categories || '-',
  };
}

export default categoryColumn;
